import { Check, Crown, Music, Users } from "lucide-react";
import { SERVICIOS, whatsappUrl } from "../data/content";

const ICONS = { basico: Music, especial: Crown, banda: Users };

export const Servicios = () => {
    return (
        <section
            id="servicios"
            data-testid="servicios-section"
            className="relative overflow-hidden bg-[hsl(var(--secondary))] py-24 md:py-32"
        >
            {/* background decoration */}
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.04] dark:opacity-[0.06]"
                style={{
                    backgroundImage: `radial-gradient(circle at 25% 30%, hsl(var(--gold)) 0.5px, transparent 0.5px),
                                      radial-gradient(circle at 75% 70%, hsl(var(--gold)) 0.5px, transparent 0.5px)`,
                    backgroundSize: "48px 48px, 48px 48px",
                }}
            />

            <div className="relative mx-auto max-w-7xl px-6 md:px-10">
                <div className="mx-auto max-w-2xl text-center">
                    <div className="mb-6 inline-flex items-center gap-3">
                        <span className="h-px w-12 bg-gold" />
                        <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">
                            Nuestros Paquetes
                        </span>
                        <span className="h-px w-12 bg-gold" />
                    </div>
                    <h2 className="font-display text-4xl leading-tight text-foreground sm:text-5xl md:text-6xl">
                        Shows pensados para
                        <span className="text-gold"> cada celebración.</span>
                    </h2>
                    <p className="mt-5 text-base text-muted-foreground md:text-lg">
                        Elige el paquete perfecto. Todos incluyen músicos profesionales,
                        equipo de sonido y transporte.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
                    {SERVICIOS.map((s) => {
                        const Icon = ICONS[s.id];
                        const isFeatured = !!s.featured;
                        return (
                            <div
                                key={s.id}
                                data-testid={`service-card-${s.id}`}
                                className={`group relative flex flex-col rounded-2xl border p-8 transition-all duration-500 hover-lift md:p-10 ${
                                    isFeatured
                                        ? "border-gold bg-gradient-to-b from-gold/10 to-transparent shadow-[0_0_60px_-20px_hsl(var(--gold)/0.5)]"
                                        : "border-border bg-card"
                                }`}
                            >
                                {/* badge */}
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                                    <span
                                        className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1 text-[10px] font-bold uppercase tracking-[0.2em] ${
                                            isFeatured
                                                ? "bg-gold text-black"
                                                : "border border-gold/50 bg-background text-gold"
                                        }`}
                                    >
                                        {s.badge}
                                    </span>
                                </div>

                                <div
                                    className={`mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl ${
                                        isFeatured ? "bg-gold text-black" : "border border-gold/30 text-gold"
                                    }`}
                                >
                                    <Icon className="h-6 w-6" />
                                </div>

                                <div className="mb-1 text-xs uppercase tracking-[0.25em] text-muted-foreground">
                                    {s.tagline}
                                </div>
                                <h3 className="font-display text-3xl text-foreground">
                                    {s.name}
                                </h3>

                                <div className="my-6 h-px w-full bg-border" />

                                <ul className="flex-1 space-y-3">
                                    {s.features.map((f) => (
                                        <li key={f} className="flex items-start gap-3 text-sm text-foreground/90">
                                            <span
                                                className={`mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full ${
                                                    isFeatured ? "bg-gold text-black" : "bg-gold/15 text-gold"
                                                }`}
                                            >
                                                <Check className="h-3 w-3" strokeWidth={3} />
                                            </span>
                                            <span>{f}</span>
                                        </li>
                                    ))}
                                </ul>

                                <a
                                    href={whatsappUrl(
                                        `Hola! Me interesa el paquete ${s.name} de Mariachi Mexicanísimo. ¿Podría recibir más información?`
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`service-cta-${s.id}`}
                                    className={`mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-semibold transition ${
                                        isFeatured
                                            ? "bg-gold text-black hover:shadow-[0_0_30px_hsl(var(--gold)/0.5)]"
                                            : "border border-gold bg-transparent text-gold hover:bg-gold hover:text-black"
                                    }`}
                                >
                                    Cotizar por WhatsApp
                                </a>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Servicios;
